import { client } from "api";
import { Company } from "models/Company";
import { CompanyLifecycleEvent } from "models/CompanyLifecycleEvent";

export type GetLifecycleEventsRequest = Pick<Company, "id">;

export type GetLifecycleEventsResponse = CompanyLifecycleEvent[];

export const getLifecycleEvents = ({ id }: GetLifecycleEventsRequest) =>
  client.get<GetLifecycleEventsResponse>(`/company/${id}/lifecycle`).then((res) => res.data);
